export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      serviceName: "アイラ地域サポート",
      serviceDropboxSettings: [
        {
          serviceDropboxId: 2,
          serviceDropboxUuid: "servicedropbox002",
          dropboxName: "スライドショー用",
          dropboxToken: "token-xxxxx-xxxxx-xxx",
          dropboxFolderName: "ila_slideshow",
          dataKbn: 3, 
        },
        {
          serviceDropboxId: 1,
          serviceDropboxUuid: "servicedropbox001",
          dropboxName: "広報用",
          dropboxToken: "token-xxxxx-xxxxx-xxx",
          dropboxFolderName: "ila_koho",
          dataKbn: 0, 
        }
      ]
    }
  }
}